import healthTranslations from "../../languages/userHealth.json";

export const getHealthTranslations = (lang) =>
  healthTranslations[lang] || healthTranslations.en;

export const isRtlLanguage = (lang) => ["ar", "ur"].includes(lang);

export const roundValue = (value, digits = 1) => {
  if (value === null || value === undefined || value === "") return "-";
  const number = Number(value);
  if (!Number.isFinite(number)) return "-";
  return Number(number.toFixed(digits));
};

export const formatPercent = (value) => {
  const rounded = roundValue(value);
  return rounded === "-" ? "-" : `${rounded}%`;
};

export const formatDateTime = (value) => {
  if (!value) return "-";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return String(value);
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const seconds = String(date.getSeconds()).padStart(2, "0");
  return `${day}/${month}/${year}, ${hours}:${minutes}:${seconds}`;
};

export const formatDateParam = (date) => {
  if (!date) return null;
  const jsDate = date?.$d || date;
  if (!(jsDate instanceof Date) || Number.isNaN(jsDate.getTime())) return null;
  const year = jsDate.getFullYear();
  const month = String(jsDate.getMonth() + 1).padStart(2, "0");
  const day = String(jsDate.getDate()).padStart(2, "0");
  return `${year}/${month}/${day}`;
};

export const getBMIColor = (bmi) => {
  const value = Number(bmi);
  if (!Number.isFinite(value)) return "var(--health-accent-color, var(--accent))";
  if (value < 18.5) return "var(--health-info-color)";
  if (value < 25) return "var(--health-success-color)";
  if (value < 30) return "var(--health-warning-color)";
  return "var(--health-danger-color)";
};

export const getRiskColor = (value) => {
  const risk = Number(value);
  if (!Number.isFinite(risk)) return "var(--health-text-color, var(--text-color))";
  if (risk <= 2) return "var(--health-success-color)";
  if (risk <= 4) return "var(--health-warning-color)";
  return "var(--health-danger-color)";
};

export const boolLabel = (value, t) =>
  value ? (t?.labels?.yes || "Yes") : (t?.labels?.no || "No");

export const PermissionDenied = ({ message, title }) => (
  <div className="configuration health-page">
    <div className="health-empty-state">
      <div>
        <h4 style={{ margin: "0 0 8px", color: "var(--text-color)" }}>{title}</h4>
        <p style={{ margin: 0 }}>{message}</p>
      </div>
    </div>
  </div>
);

export const HealthPageHeader = ({ eyebrow, title, subtitle, actions }) => (
  <div className="health-page-header">
    <div className="health-page-title-group">
      {eyebrow ? <p className="health-eyebrow">{eyebrow}</p> : null}
      <h2 className="health-page-title">{title}</h2>
      {subtitle ? <p className="health-page-subtitle">{subtitle}</p> : null}
    </div>
    {actions ? <div className="health-header-actions">{actions}</div> : null}
  </div>
);

export const SummaryCard = ({ label, value, note, color }) => (
  <div className="health-summary-card">
    <span className="health-summary-label">{label}</span>
    <strong className="health-summary-value" style={color ? { color } : undefined}>
      {value ?? "-"}
    </strong>
    {note ? <span className="health-summary-note">{note}</span> : <span />}
  </div>
);

export const Section = ({ title, children, wide = false, full = false }) => (
  <section className={`health-card ${wide ? "health-card-wide" : ""} ${full ? "health-card-full" : ""}`}>
    <h3>{title}</h3>
    <div className="health-fields">{children}</div>
  </section>
);

export const Field = ({ label, value, color }) => (
  <div className="health-field">
    <span className="health-label">{label}</span>
    <span className="health-value" style={color ? { color } : undefined}>
      {value ?? "-"}
    </span>
  </div>
);
